import { team } from '../data';
import s from './Team.module.css';
export default function Team() {
  return (
    <section id="team" className="light-section" aria-label="Team">
      <div className="section-inner">
        <div className={s.header}>
          <div>
            <div className="kicker"><div className="kicker-line-light"/><span className="kicker-text-light">The People</span></div>
            <h2 className={`section-h ${s.heading}`}>The Humans Behind<br/>the Code</h2>
          </div>
          <p className={s.sub}>Real people who genuinely care about your project.</p>
        </div>
        <div className={s.grid}>
          {team.map(m => (
            <div key={m.name} className={s.card}>
              <div className={s.avatar}>{m.initials}</div>
              <div className={s.name}>{m.name}</div>
              <div className={s.role}>{m.role}</div>
              <p className={s.bio}>{m.bio}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
